import {IClientType} from "./IClientType";

export default interface IClient {
	type: IClientType,
}

export const defaultClient: IClient = {
	type: IClientType.MARKETING,
}
